import * as yup from "yup";

export type VacancyDescriptionForm = {
  title: string;
  description: string;
  comment: string;
};

export const vacancyDescriptionSchema = yup.object({
  vacancy_name: yup.string().trim().required("Поле обязательно для заполнения"),
  vacancy_description: yup.string().trim().required("Поле обязательно для заполнения"),
  user_comments: yup.string(),
});
